var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCordovainline = function SvgCordovainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#444",
    d: "M14.547 15.49h-2.59l.18-2.214h-1.272l-.18 2.213h-5.37l-.18-2.213H3.863l.18 2.213h-2.59L0 5.9 3.637 0h8.726L16 5.898zM11.633 2.952H9.299l.158 1.106H6.543l.158-1.106H4.367l-1.46 2.945.73 5.898h8.726l.73-5.898zm-1.272 6.89c-.204 0-.362-.61-.362-1.374 0-.763.166-1.373.361-1.373.204 0 .362.61.362 1.373s-.158 1.374-.361 1.374m-4.586.114c-.203 0-.361-.61-.361-1.373s.165-1.374.361-1.374c.203 0 .361.61.361 1.374 0 .763-.165 1.373-.36 1.373"
  })));
};
export default SvgCordovainline;